"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getZapOwnerId(zap) {
    return zap.ownerId || zap.owner_id;
}
exports.default = getZapOwnerId;
